/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Alternatives_TitleInputs */

const en_directory_taxonomy_alternatives_title = /** @type {(inputs: Directory_Taxonomy_Alternatives_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find another way to solve the same problem`)
};

const zh_directory_taxonomy_alternatives_title = /** @type {(inputs: Directory_Taxonomy_Alternatives_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用另一种方式解决同一个问题`)
};

/**
* | output |
* | --- |
* | "Find another way to solve the same problem" |
*
* @param {Directory_Taxonomy_Alternatives_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_alternatives_title = /** @type {((inputs?: Directory_Taxonomy_Alternatives_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Alternatives_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_alternatives_title(inputs)
	return zh_directory_taxonomy_alternatives_title(inputs)
});
export { directory_taxonomy_alternatives_title as "directory.taxonomy.alternatives.title" }